import { Controller } from "@hotwired/stimulus"
// TODO: Next time we modify or use the slideover component, I'll try to replace the event_emitter controller by listening to a TurboFrame lifecycle event already being emitted by hotwire. That will simplify the code and how we need to create the links.

export default class extends Controller {
  static values = { eventName: String, onLoad: Boolean }

  connect() {
    if (this.hasOnLoadValue && this.onLoadValue) {
      this.emit();
    }
  }
  emit() {
    if (this.hasEventNameValue) {
      const event = new CustomEvent(this.eventNameValue, { bubbles: true, cancelable: true, details: null })
      this.element.dispatchEvent(event)
    } else {
      console.log("EventName not defined and impossible to emit")
    }
  }
}
